<template>
	<div
		:class="[
			'truncated-value',
			...variantClassList,
			disabled && 'is-disabled'
		]"
		:disabled="disabled"
	>
		<Label
			class="truncated-value__label"
			:labelText="labelText"
			:forElementId="uid"
			v-if="labelText"
		>
			<template v-slot:leading>
				<slot name="beforeLabel"> </slot>
			</template>

			<template v-slot:trailing>
				<slot name="afterLabel"> </slot>
			</template>
		</Label>
		<div
			class="truncated-value__container"
			:style="truncatedStyle"
			:id="uid"
		>
			<span
				class="truncated-value__txt"
				ref="truncatedValueTooltip"
				@mouseenter="onMouseEnter"
				@mouseleave="onMouseLeave"
				>{{ value }}</span
			>
			<span
				class="truncated-value__suffix"
				v-if="suffixValue"
				ref="suffix"
				@mouseenter="onMouseEnter"
				@mouseleave="onMouseLeave"
			>
				{{ separator }}{{ suffixValue }}
			</span>
			<Tooltip
				placement="top"
				:visible="tooltipVisible"
				trackedRefName="truncatedValueTooltip"
				positionStrategy="fixed"
				:offset="[0, 16]"
			>
				{{ value }}{{ separator }}{{ suffixValue }}
			</Tooltip>
		</div>
	</div>
</template>

<script>
import componentVariantMixin from '@/mixins/component-variant-mixin';
import BaseComponentMixin from '@/mixins/base-component-mixin.js';
import Tooltip from '@/components/shells/tooltip/tooltip.vue';
import Label from '@/components/forms/shared-stateless-elements/label.vue';
import variantClasses from './variant-classes/truncated-value-variant-classes';

export default {
	name: 'TruncatedValue',
	mixins: [componentVariantMixin, BaseComponentMixin],
	components: {
		Tooltip,
		Label
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		labelText: {
			type: String,
			default: null
		},
		suffixValue: {
			type: String,
			default: ''
		},
		hasTooltip: {
			type: Boolean,
			default: true
		},
		separator: {
			type: String,
			default: ' '
		},
		width: {
			type: [String, Number],
			default: null
		}
	},
	data() {
		return {
			tooltipVisible: false
		};
	},
	created() {
		this.variantClasses = variantClasses;
	},
	computed: {
		isEllipsIsActive() {
			const span = this.$refs.truncatedValueTooltip;

			let active;

			if (span) {
				active = span.offsetWidth < span.scrollWidth;
			}

			return active;
		},
		truncatedStyle() {
			if (typeof this.width === 'number') {
				return {
					width: `${this.width}px`
				};
			} else {
				return {
					width: this.width
				};
			}
		}
	},
	methods: {
		onMouseEnter() {
			if (this.hasTooltip && this.isEllipsIsActive) {
				this.tooltipVisible = true;
			}
		},
		onMouseLeave() {
			this.tooltipVisible = false;
		},
		onBlur() {
			this.tooltipVisible = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.truncated-value {
	display: block;

	&__label {
		display: flex;
		margin-bottom: $gutter-sm;
	}

	&__container {
		display: flex;
		align-items: center;
		gap: $gutter-xs;
	}

	&__txt {
		display: block;
		@include ellipsis;
	}

	&__suffix {
		margin-left: $gutter-xs;
		display: flex;
		align-items: center;
		gap: $gutter-xs;
		white-space: nowrap;
	}
}
@include left-label('truncated-value');
</style>
